import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';

// local
import commandEngine from './CommandEngine';
import sim from './tickerSimulator';
import { CMD_TICKER_REGISTRY_KEY, META_TYPE, META_VER } from './tickerCommandRegisteryType';

/**
 * @param {string} market - e.g. 'near-euro'
 * @returns {{target: string, eMarket: string}}
 */
const parseMarket = (market) => ({
    target: market.toLowerCase(),
    eMarket: market.toUpperCase(),
});

/**
 * Opens a card for real BE data — no mock loop, just waits for cardDataListener.
 * @param {string} market - e.g. 'near-euro'
 */
const openReal = (market) => {
    let { target } = parseMarket(market);

    if (!target.includes('-')) {
        target = target + '-eur';
    }

    cardPainterManager.openCard(CMD_TICKER_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target });
};

/**
 * Registers the /ticker command with the CommandEngine.
 * Call once at module load from YourLibraryTab (via CommandEngine.bootup).
 *
 * /ticker <market>                        — opens a card for real BE data, e.g. /ticker near-euro
 * /ticker sim start <market> <low> <high> — starts (or re-ranges) a mock stream, e.g. /ticker sim start near-euro 1.6 2.1
 * /ticker sim stop [market]               — stops the mock stream for market, or all if omitted
 */
export function registerTickerCommand() {
    commandEngine.register('/ticker', {
        hint: '<market> | sim start <market> <low> <high> | sim stop [market]',
        params: [],
        handler: (params) => {
            const [first, second, third, fourth] = params;

            if (first === 'sim') {
                if (second === 'start') {
                    const low = parseFloat(third);
                    const high = parseFloat(fourth);
                    if (!third || Number.isNaN(low) || Number.isNaN(high)) return; // invalid input, silently ignore
                    const { target, eMarket } = parseMarket(third);
                    sim.start(target, eMarket, low, high);
                    return;
                }
                if (second === 'stop') {
                    const target = third ? parseMarket(third).target : undefined;
                    sim.stop(target);
                    return;
                }
                return; // invalid sim sub-command, silently ignore
            }

            if (!first) return; // no market given, nothing to do
            openReal(first);
        },
    });
}
